// extracted by extract-css-chunks-webpack-plugin
module.exports = {"external-links":"TPRbC","no-search":"ChkZx","search":"-ORuB"};